import React, { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tag
} from 'antd'
import { Panel } from 'rsuite'
import {
  DeleteOutlined,
  EditOutlined,
  HomeOutlined,
  PlusOutlined
} from '@ant-design/icons'
import _ from 'lodash'
import { useParams } from 'react-router-dom'

import { useRequestsEvents } from '../../../../../hooks/useRequestsEvents'

import {
  EmptyResult,
  ErrorResult,
  ForbiddenResult,
  LoaderBackDrop
} from '../../../../../components/feedbacks'


export function PromotionResidentialUsers() {
  /*
   * Promotion
   */
  const { promotionId } = useParams()


  /*
   * Requests
   */
  const {
    getPromotionResidentialUsers,
    createPromotionResidentialUser,
    updatePromotionResidentialUser,
    deletePromotionResidentialUser,

    getPromotionApartments,

    getPromotionResidentialUserApartments,
    createPromotionResidentialUserApartment,
    updatePromotionResidentialUserApartment,
    deletePromotionResidentialUserApartment
  } = useRequestsEvents()


  /*
   * Forms
   */
  const [form] = Form.useForm()

  const [apartmentForm] =
    Form.useForm()


  /*
   * Users state
   */
  const [componentCfg, setComponentCfg] = useState({
    data: [],
    isLoaded: false,
    isError: false,
    isForbidden: false
  })


  /*
   * User create / edit modal
   */
  const [modalCfg, setModalCfg] = useState({
    open: false,
    mode: 'create',
    selected: null,
    isSubmitting: false
  })


  /*
   * Apartments modal
   */
  const [apartmentsCfg, setApartmentsCfg] = useState({
    open: false,

    selectedUser: null,

    assigned: [],

    available: [],

    isLoaded: false,

    isError: false,

    isSubmitting: false
  })


  /*
   * Apartment create / edit modal
   */
  const [apartmentModalCfg, setApartmentModalCfg] = useState({
    open: false,
    mode: 'create',
    selected: null,
    isSubmitting: false
  })


  /*
   * Load users
   */
  const loadUsers = () => {
    setComponentCfg(prev => ({
      ...prev,
      isLoaded: false,
      isError: false,
      isForbidden: false
    }))


    getPromotionResidentialUsers(
      promotionId,

      (result) => {
        setComponentCfg({
          data:
            _.get(
              result,
              'data',
              []
            ),

          isLoaded: true,
          isError: false,
          isForbidden: false
        })
      },

      (err) => {
        if (
          err === 403
        ) {
          setComponentCfg({
            data: [],
            isLoaded: true,
            isError: false,
            isForbidden: true
          })
        } else {
          setComponentCfg({
            data: [],
            isLoaded: true,
            isError: true,
            isForbidden: false
          })
        }
      }
    )
  }


  /*
   * Initial load
   */
  useEffect(
    () => {
      let isMounted = true


      if (
        componentCfg.isLoaded
      ) {
        return () => {
          isMounted = false
        }
      }


      getPromotionResidentialUsers(
        promotionId,

        (result) => {
          if (
            !isMounted
          ) {
            return null
          }


          setComponentCfg({
            data:
              _.get(
                result,
                'data',
                []
              ),

            isLoaded: true,
            isError: false,
            isForbidden: false
          })
        },

        (err) => {
          if (
            !isMounted
          ) {
            return null
          }


          if (
            err === 403
          ) {
            setComponentCfg({
              data: [],
              isLoaded: true,
              isError: false,
              isForbidden: true
            })
          } else {
            setComponentCfg({
              data: [],
              isLoaded: true,
              isError: true,
              isForbidden: false
            })
          }
        }
      )


      return () => {
        isMounted = false
      }
    },

    [
      componentCfg.isLoaded,
      promotionId
    ]
  )


  /*
   * Open create user
   */
  const handlerOpenCreate = () => {
    form.resetFields()


    form.setFieldsValue({
      user_name: '',
      user_lastname: '',
      user_language_id: 'ca',
      user_email: '',
      user_password: '',
      user_is_promotion_admin: false
    })


    setModalCfg({
      open: true,
      mode: 'create',
      selected: null,
      isSubmitting: false
    })
  }


  /*
   * Open edit user
   */
  const handlerOpenEdit = (record) => {
    form.resetFields()


    form.setFieldsValue({
      user_name:
        record.user_name || '',

      user_lastname:
        record.user_lastname || '',

      user_language_id:
        record.user_language_id || 'ca',

      user_email:
        record.user_email || '',

      user_password:
        '',

      user_is_promotion_admin:
        record.user_is_promotion_admin === true ||
        record.user_is_promotion_admin === 1 ||
        record.user_is_promotion_admin === '1'
    })


    setModalCfg({
      open: true,
      mode: 'edit',
      selected: record,
      isSubmitting: false
    })
  }


  /*
   * Close user modal
   */
  const handlerCloseModal = () => {
    if (
      modalCfg.isSubmitting
    ) {
      return
    }


    form.resetFields()


    setModalCfg({
      open: false,
      mode: 'create',
      selected: null,
      isSubmitting: false
    })
  }


  /*
   * Create / update user
   */
  const handlerFinish = (values) => {
    setModalCfg(prev => ({
      ...prev,
      isSubmitting: true
    }))


    /*
     * EDIT
     */
    if (
      modalCfg.mode === 'edit'
    ) {
      const relationId =
        _.get(
          modalCfg,
          'selected.rel_usr_promo_id',
          null
        )


      if (
        !relationId
      ) {
        setModalCfg(prev => ({
          ...prev,
          isSubmitting: false
        }))

        return
      }


      const payload = {
        user_name:
          values.user_name
            ? values.user_name.trim()
            : '',

        user_lastname:
          values.user_lastname
            ? values.user_lastname.trim()
            : '',

        user_language_id:
          values.user_language_id,

        user_email:
          values.user_email
            ? values.user_email
              .trim()
              .toLowerCase()
            : '',

        user_is_promotion_admin:
          values.user_is_promotion_admin
            ? 1
            : 0
      }


      /*
       * Password only when changed
       */
      if (
        values.user_password &&
        String(
          values.user_password
        ).length > 0
      ) {
        payload.user_password =
          values.user_password
      }


      updatePromotionResidentialUser(
        promotionId,
        relationId,
        payload,

        () => {
          form.resetFields()


          setModalCfg({
            open: false,
            mode: 'create',
            selected: null,
            isSubmitting: false
          })


          loadUsers()
        },

        () => {
          setModalCfg(prev => ({
            ...prev,
            isSubmitting: false
          }))
        }
      )


      return
    }


    /*
     * CREATE
     */
    const payload = {
      user_email:
        values.user_email
          ? values.user_email
            .trim()
            .toLowerCase()
          : '',

      user_is_promotion_admin:
        values.user_is_promotion_admin
          ? 1
          : 0
    }


    if (
      values.user_name
    ) {
      payload.user_name =
        values.user_name.trim()
    }


    if (
      values.user_lastname
    ) {
      payload.user_lastname =
        values.user_lastname.trim()
    }


    if (
      values.user_language_id
    ) {
      payload.user_language_id =
        values.user_language_id
    }


    if (
      values.user_password
    ) {
      payload.user_password =
        values.user_password
    }


    createPromotionResidentialUser(
      promotionId,
      payload,

      () => {
        form.resetFields()


        setModalCfg({
          open: false,
          mode: 'create',
          selected: null,
          isSubmitting: false
        })


        loadUsers()
      },

      () => {
        setModalCfg(prev => ({
          ...prev,
          isSubmitting: false
        }))
      }
    )
  }

  /*
   * Delete user promotion relation
   *
   * Backend can return:
   *
   * user_deleted = false
   *      User has other promotions.
   *      Only current promotion relation was deleted.
   *
   * user_deleted = true
   *      User had no other promotions.
   *      User was also deleted from database.
   */
  const handlerDelete = (record) => {
    const relationId =
      _.get(
        record,
        'rel_usr_promo_id',
        null
      )

    if (
      !relationId
    ) {
      return
    }

    deletePromotionResidentialUser(
      promotionId,
      relationId,

      (result) => {
        const userDeleted =
          _.get(
            result,
            'data.user_deleted',
            false
          )

        const remainingPromotions =
          _.get(
            result,
            'data.remaining_promotions',
            null
          )

        /*
         * User has been completely deleted
         */
        if (
          userDeleted === true
        ) {
          Modal.success({
            title:
              'Usuari eliminat',

            content:
              "L'usuari s'ha eliminat de la promoció i també de la base de dades perquè no tenia cap altra promoció associada."
          })
        } else {
          /*
           * Only promotion relation has been deleted
           */
          Modal.success({
            title:
              'Usuari eliminat de la promoció',

            content:
              remainingPromotions !== null
                ? `L'usuari s'ha eliminat d'aquesta promoció. Encara té ${remainingPromotions} promoció${remainingPromotions === 1 ? '' : 'ns'} associada${remainingPromotions === 1 ? '' : 'es'}, per tant es manté a la base de dades.`
                : "L'usuari s'ha eliminat d'aquesta promoció, però es manté a la base de dades perquè encara està associat a altres promocions."
          })
        }

        loadUsers()
      }
    )
  }

  /*
   * Load apartments of selected user
   */
  const loadUserApartments = (
    user = apartmentsCfg.selectedUser
  ) => {
    const relationId =
      _.get(
        user,
        'rel_usr_promo_id',
        null
      )


    if (
      !relationId
    ) {
      return
    }


    setApartmentsCfg(prev => ({
      ...prev,
      isLoaded: false,
      isError: false
    }))


    let assignedApartments = null
    let availableApartments = null

    let assignedLoaded = false
    let availableLoaded = false

    let failed = false


    /*
     * Finish only when both requests completed
     */
    const finishLoad = () => {
      if (
        failed ||
        !assignedLoaded ||
        !availableLoaded
      ) {
        return
      }


      setApartmentsCfg(prev => ({
        ...prev,

        assigned:
          assignedApartments || [],

        available:
          availableApartments || [],

        isLoaded: true,
        isError: false
      }))
    }


    /*
     * Assigned apartments
     */
    getPromotionResidentialUserApartments(
      promotionId,
      relationId,

      (result) => {
        assignedApartments =
          _.get(
            result,
            'data',
            []
          )

        assignedLoaded = true

        finishLoad()
      },

      () => {
        failed = true

        setApartmentsCfg(prev => ({
          ...prev,
          assigned: [],
          available: [],
          isLoaded: true,
          isError: true
        }))
      }
    )


    /*
     * All apartments from promotion
     */
    getPromotionApartments(
      promotionId,

      (result) => {
        availableApartments =
          _.get(
            result,
            'data',
            []
          )

        availableLoaded = true

        finishLoad()
      },

      () => {
        failed = true

        setApartmentsCfg(prev => ({
          ...prev,
          assigned: [],
          available: [],
          isLoaded: true,
          isError: true
        }))
      }
    )
  }


  /*
   * Open apartment management
   */
  const handlerOpenApartments = (record) => {
    setApartmentsCfg({
      open: true,

      selectedUser:
        record,

      assigned: [],

      available: [],

      isLoaded: false,

      isError: false,

      isSubmitting: false
    })


    loadUserApartments(
      record
    )
  }


  /*
   * Close apartments modal
   */
  const handlerCloseApartments = () => {
    if (
      apartmentsCfg.isSubmitting
    ) {
      return
    }


    apartmentForm.resetFields()


    setApartmentModalCfg({
      open: false,
      mode: 'create',
      selected: null,
      isSubmitting: false
    })


    setApartmentsCfg({
      open: false,
      selectedUser: null,
      assigned: [],
      available: [],
      isLoaded: false,
      isError: false,
      isSubmitting: false
    })
  }


  /*
   * Open add apartment modal
   */
  const handlerOpenAddApartment = () => {
    apartmentForm.resetFields()


    apartmentForm.setFieldsValue({
      apartment_id: null,

      user_is_apartment_tenant:
        true,

      user_is_apartment_owner:
        false
    })


    setApartmentModalCfg({
      open: true,
      mode: 'create',
      selected: null,
      isSubmitting: false
    })
  }


  /*
   * Open edit apartment relation
   */
  const handlerOpenEditApartment = (record) => {
    apartmentForm.resetFields()


    apartmentForm.setFieldsValue({
      apartment_id:
        record.apartment_id,

      user_is_apartment_tenant:
        record.user_is_apartment_tenant === true ||
        record.user_is_apartment_tenant === 1 ||
        record.user_is_apartment_tenant === '1',

      user_is_apartment_owner:
        record.user_is_apartment_owner === true ||
        record.user_is_apartment_owner === 1 ||
        record.user_is_apartment_owner === '1'
    })


    setApartmentModalCfg({
      open: true,
      mode: 'edit',
      selected: record,
      isSubmitting: false
    })
  }


  /*
   * Close apartment relation modal
   */
  const handlerCloseApartmentModal = () => {
    if (
      apartmentModalCfg.isSubmitting
    ) {
      return
    }


    apartmentForm.resetFields()


    setApartmentModalCfg({
      open: false,
      mode: 'create',
      selected: null,
      isSubmitting: false
    })
  }


  /*
   * Create / update apartment relation
   */
  const handlerApartmentFinish = (values) => {
    const relationId =
      _.get(
        apartmentsCfg,
        'selectedUser.rel_usr_promo_id',
        null
      )


    if (
      !relationId
    ) {
      return
    }


    setApartmentModalCfg(prev => ({
      ...prev,
      isSubmitting: true
    }))


    const payload = {
      user_is_apartment_tenant:
        values.user_is_apartment_tenant
          ? 1
          : 0,

      user_is_apartment_owner:
        values.user_is_apartment_owner
          ? 1
          : 0
    }


    /*
     * EDIT
     */
    if (
      apartmentModalCfg.mode === 'edit'
    ) {
      const apartmentId =
        _.get(
          apartmentModalCfg,
          'selected.apartment_id',
          null
        )


      if (
        !apartmentId
      ) {
        setApartmentModalCfg(prev => ({
          ...prev,
          isSubmitting: false
        }))

        return
      }


      updatePromotionResidentialUserApartment(
        promotionId,
        relationId,
        apartmentId,
        payload,

        () => {
          apartmentForm.resetFields()


          setApartmentModalCfg({
            open: false,
            mode: 'create',
            selected: null,
            isSubmitting: false
          })


          loadUserApartments()
        },

        () => {
          setApartmentModalCfg(prev => ({
            ...prev,
            isSubmitting: false
          }))
        }
      )


      return
    }


    /*
     * CREATE
     */
    payload.apartment_id =
      values.apartment_id


    createPromotionResidentialUserApartment(
      promotionId,
      relationId,
      payload,

      () => {
        apartmentForm.resetFields()


        setApartmentModalCfg({
          open: false,
          mode: 'create',
          selected: null,
          isSubmitting: false
        })


        loadUserApartments()
      },

      () => {
        setApartmentModalCfg(prev => ({
          ...prev,
          isSubmitting: false
        }))
      }
    )
  }


  /*
   * Delete apartment relation
   */
  const handlerDeleteApartment = (record) => {
    const relationId =
      _.get(
        apartmentsCfg,
        'selectedUser.rel_usr_promo_id',
        null
      )

    const apartmentId =
      _.get(
        record,
        'apartment_id',
        null
      )


    if (
      !relationId ||
      !apartmentId
    ) {
      return
    }


    deletePromotionResidentialUserApartment(
      promotionId,
      relationId,
      apartmentId,

      () => {
        loadUserApartments()
      }
    )
  }


  /*
   * Assigned apartment ids
   */
  const assignedApartmentIds =
    useMemo(
      () => {
        return apartmentsCfg.assigned.map(
          item => Number(
            item.apartment_id
          )
        )
      },

      [
        apartmentsCfg.assigned
      ]
    )


  /*
   * Apartment select options
   *
   * Hide apartments already assigned
   */
  const apartmentOptions =
    useMemo(
      () => {
        return apartmentsCfg.available
          .filter(
            apartment => {
              return !assignedApartmentIds.includes(
                Number(apartment.apartment_id)
              )
            }
          )
          .map(
            apartment => {
              const blockName =
                apartment.block_name ||
                apartment.block_reference ||
                '-'

              const floorName =
                apartment.floor_name ||
                '-'

              const apartmentName =
                apartment.apartment_name ||
                apartment.apartment_id ||
                '-'

              return {
                value: apartment.apartment_id,
                label: `${blockName} - ${floorName} - ${apartmentName}`
              }
            }
          )
      },
      [
        apartmentsCfg.available,
        assignedApartmentIds
      ]
    )


  /*
   * User table
   */
  const columns = useMemo(
    () => {
      return [
        {
          title: 'ID',
          dataIndex: 'user_id',
          key: 'user_id',
          width: 80
        },

        {
          title: 'Nom',
          dataIndex: 'user_name',
          key: 'user_name',

          render: value => {
            return value || '-'
          }
        },

        {
          title: 'Cognoms',
          dataIndex: 'user_lastname',
          key: 'user_lastname',

          render: value => {
            return value || '-'
          }
        },

        {
          title: 'Correu electrònic',
          dataIndex: 'user_email',
          key: 'user_email',

          render: value => {
            return value || '-'
          }
        },

        {
          title: 'Idioma',
          dataIndex: 'user_language_id',
          key: 'user_language_id',
          width: 100,

          render: value => {
            if (
              !value
            ) {
              return '-'
            }


            return String(
              value
            ).toUpperCase()
          }
        },

        {
          title: 'Administrador',
          dataIndex: 'user_is_promotion_admin',
          key: 'user_is_promotion_admin',
          width: 140,
          align: 'center',

          render: value => {
            const isAdmin =
              value === true ||
              value === 1 ||
              value === '1'


            return (
              <Tag
                color={
                  isAdmin
                    ? 'green'
                    : 'default'
                }
              >
                {
                  isAdmin
                    ? 'Sí'
                    : 'No'
                }
              </Tag>
            )
          }
        },

        {
          title: 'Accions',
          key: 'actions',
          width: 170,
          align: 'center',

          render: (_, record) => {
            return (
              <Space>
                {/*
                  * Apartments
                  */}
                <Button
                  type="text"

                  title="Habitatges"

                  icon={
                    <HomeOutlined />
                  }

                  onClick={() => {
                    handlerOpenApartments(
                      record
                    )
                  }}
                />


                {/*
                  * Edit
                  */}
                <Button
                  type="text"

                  title="Editar"

                  icon={
                    <EditOutlined />
                  }

                  onClick={() => {
                    handlerOpenEdit(
                      record
                    )
                  }}
                />


                {/*
                  * Delete
                  */}
                <Popconfirm
                  title="Eliminar usuari"

                  description={
                    <>
                      <div>
                        Vols eliminar l'accés d'aquest usuari a la promoció?
                      </div>

                      <div
                        style={{
                          marginTop: '8px'
                        }}
                      >
                        Si no està associat a cap altra promoció,
                        també s'eliminarà de la base de dades.
                      </div>
                    </>
                  }

                  okText="Sí"

                  cancelText="No"

                  onConfirm={() => {
                    handlerDelete(
                      record
                    )
                  }}
                >
                  <Button
                    type="text"
                    danger

                    title="Eliminar"

                    icon={
                      <DeleteOutlined />
                    }
                  />
                </Popconfirm>
              </Space>
            )
          }
        }
      ]
    },

    [
      promotionId
    ]
  )


  /*
   * Apartment relation table
   */
  const apartmentColumns = useMemo(
    () => {
      return [
        {
          title: 'Bloc',
          dataIndex: 'block_name',
          key: 'block_name',

          render: value => {
            return value || '-'
          }
        },

        {
          title: 'Planta',
          dataIndex: 'floor_name',
          key: 'floor_name',

          render: value => {
            return value || '-'
          }
        },

        {
          title: 'Habitatge',
          dataIndex: 'apartment_name',
          key: 'apartment_name',

          render: (
            value,
            record
          ) => {
            return (
              value ||
              record.apartment_id ||
              '-'
            )
          }
        },

        {
          title: 'Llogater',
          dataIndex: 'user_is_apartment_tenant',
          key: 'user_is_apartment_tenant',
          width: 100,
          align: 'center',

          render: value => {
            const active =
              value === true ||
              value === 1 ||
              value === '1'


            return (
              <Tag
                color={
                  active
                    ? 'green'
                    : 'default'
                }
              >
                {
                  active
                    ? 'Sí'
                    : 'No'
                }
              </Tag>
            )
          }
        },

        {
          title: 'Propietari',
          dataIndex: 'user_is_apartment_owner',
          key: 'user_is_apartment_owner',
          width: 110,
          align: 'center',

          render: value => {
            const active =
              value === true ||
              value === 1 ||
              value === '1'


            return (
              <Tag
                color={
                  active
                    ? 'green'
                    : 'default'
                }
              >
                {
                  active
                    ? 'Sí'
                    : 'No'
                }
              </Tag>
            )
          }
        },

        {
          title: 'Accions',
          key: 'actions',
          width: 120,
          align: 'center',

          render: (
            _,
            record
          ) => {
            return (
              <Space>
                <Button
                  type="text"

                  icon={
                    <EditOutlined />
                  }

                  onClick={() => {
                    handlerOpenEditApartment(
                      record
                    )
                  }}
                />


                <Popconfirm
                  title="Eliminar habitatge"

                  description="Vols eliminar l'habitatge d'aquest usuari?"

                  okText="Sí"

                  cancelText="No"

                  onConfirm={() => {
                    handlerDeleteApartment(
                      record
                    )
                  }}
                >
                  <Button
                    type="text"
                    danger

                    icon={
                      <DeleteOutlined />
                    }
                  />
                </Popconfirm>
              </Space>
            )
          }
        }
      ]
    },

    [
      apartmentsCfg.selectedUser
    ]
  )


  /*
   * Panel border
   */
  const isPanelBordered =
    !componentCfg.isLoaded ||
    componentCfg.isError ||
    componentCfg.isForbidden ||
    _.isEmpty(
      componentCfg.data
    )


  return (
    <>
      {/*
        * MAIN USERS
        */}
      <LoaderBackDrop
        active={
          !componentCfg.isLoaded
        }

        loader

        background="white"

        top
      >
        <Panel
          className="filled-table-panel"

          style={{
            borderRadius:
              '4px'
          }}

          bordered={
            isPanelBordered
          }

          bodyFill
        >
          {(() => {
            if (
              componentCfg.isForbidden
            ) {
              return (
                <ForbiddenResult
                  compact={true}
                />
              )
            }


            if (
              componentCfg.isError
            ) {
              return (
                <ErrorResult
                  compact={true}
                />
              )
            }


            return (
              <>
                <div
                  style={{
                    display:
                      'flex',

                    justifyContent:
                      'flex-end',

                    padding:
                      '16px 16px 0 16px'
                  }}
                >
                  <Button
                    type="primary"

                    icon={
                      <PlusOutlined />
                    }

                    onClick={
                      handlerOpenCreate
                    }
                  >
                    Afegir usuari
                  </Button>
                </div>


                {
                  componentCfg.isLoaded &&
                    _.isEmpty(
                      componentCfg.data
                    )
                    ? (
                      <EmptyResult
                        compact={true}
                      />
                    )
                    : (
                      <Table
                        rowKey={
                          record => {
                            return (
                              record.rel_usr_promo_id ||
                              record.user_id
                            )
                          }
                        }

                        columns={
                          columns
                        }

                        dataSource={
                          componentCfg.data
                        }

                        pagination={
                          false
                        }

                        scroll={{
                          x: true
                        }}

                        size="middle"
                      />
                    )
                }
              </>
            )
          })()}
        </Panel>
      </LoaderBackDrop>


      {/*
        * USER CREATE / EDIT MODAL
        */}
      <Modal
        open={
          modalCfg.open
        }

        title={
          modalCfg.mode === 'edit'
            ? 'Editar usuari residencial'
            : 'Afegir usuari residencial'
        }

        onCancel={
          handlerCloseModal
        }

        footer={
          null
        }

        destroyOnClose
      >
        <Form
          form={
            form
          }

          layout="vertical"

          name="promotion_residential_user_form"

          autoComplete="off"

          onFinish={
            handlerFinish
          }

          initialValues={{
            user_language_id:
              'ca',

            user_is_promotion_admin:
              false
          }}
        >
          <Row
            gutter={
              16
            }
          >
            <Col
              span={
                12
              }
            >
              <Form.Item
                label="Nom"

                name="user_name"

                rules={
                  modalCfg.mode === 'edit'
                    ? [
                      {
                        required:
                          true,

                        message:
                          'Introdueix el nom'
                      }
                    ]
                    : []
                }
              >
                <Input />
              </Form.Item>
            </Col>


            <Col
              span={
                12
              }
            >
              <Form.Item
                label="Cognoms"

                name="user_lastname"

                rules={
                  modalCfg.mode === 'edit'
                    ? [
                      {
                        required:
                          true,

                        message:
                          'Introdueix els cognoms'
                      }
                    ]
                    : []
                }
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>


          <Row
            gutter={
              16
            }
          >
            <Col
              span={
                24
              }
            >
              <Form.Item
                label="Correu electrònic"

                name="user_email"

                rules={[
                  {
                    required:
                      true,

                    message:
                      'Introdueix el correu electrònic'
                  },

                  {
                    type:
                      'email',

                    message:
                      'El correu electrònic no és vàlid'
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>


          <Row
            gutter={
              16
            }
          >
            <Col
              span={
                12
              }
            >
              <Form.Item
                label="Idioma"

                name="user_language_id"

                rules={
                  modalCfg.mode === 'edit'
                    ? [
                      {
                        required:
                          true,

                        message:
                          'Selecciona un idioma'
                      }
                    ]
                    : []
                }
              >
                <Select
                  options={[
                    {
                      value:
                        'ca',

                      label:
                        'Català'
                    },

                    {
                      value:
                        'es',

                      label:
                        'Español'
                    },

                    {
                      value:
                        'en',

                      label:
                        'English'
                    }
                  ]}
                />
              </Form.Item>
            </Col>


            <Col
              span={
                12
              }
            >
              <Form.Item
                label={
                  modalCfg.mode === 'edit'
                    ? 'Nova contrasenya'
                    : 'Contrasenya'
                }

                name="user_password"

                extra={
                  modalCfg.mode === 'edit'
                    ? 'Deixa-la buida per mantenir la contrasenya actual.'
                    : null
                }
              >
                <Input.Password
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
          </Row>


          <Row
            gutter={
              16
            }
          >
            <Col
              span={
                24
              }
            >
              <Form.Item
                label="Administrador de la promoció"

                name="user_is_promotion_admin"

                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>


          {
            modalCfg.mode === 'create' &&
            (
              <div
                style={{
                  marginBottom:
                    '16px',

                  color:
                    '#8c8c8c',

                  fontSize:
                    '12px'
                }}
              >
                Si el correu ja existeix com a usuari residencial,
                només s'associarà a aquesta promoció. Si és un usuari
                nou, cal informar nom, cognoms, idioma i contrasenya.
              </div>
            )
          }


          {
            modalCfg.mode === 'edit' &&
            (
              <div
                style={{
                  marginBottom:
                    '16px',

                  color:
                    '#8c8c8c',

                  fontSize:
                    '12px'
                }}
              >
                Pots modificar les dades de l'usuari residencial.
                La contrasenya només es canviarà si n'escrius una de nova.
              </div>
            )
          }


          <Row
            justify="end"
          >
            <Col>
              <Space>
                <Button
                  onClick={
                    handlerCloseModal
                  }

                  disabled={
                    modalCfg.isSubmitting
                  }
                >
                  Cancel·lar
                </Button>


                <Button
                  type="primary"

                  htmlType="submit"

                  loading={
                    modalCfg.isSubmitting
                  }
                >
                  {
                    modalCfg.mode === 'edit'
                      ? 'Actualitzar'
                      : 'Afegir'
                  }
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>


      {/*
        * USER APARTMENTS MODAL
        */}
      <Modal
        open={
          apartmentsCfg.open
        }

        title={
          apartmentsCfg.selectedUser
            ? `Habitatges de ${apartmentsCfg.selectedUser.user_name || ''} ${apartmentsCfg.selectedUser.user_lastname || ''}`
            : 'Habitatges'
        }

        width={
          900
        }

        onCancel={
          handlerCloseApartments
        }

        footer={
          null
        }

        destroyOnClose
      >
        <LoaderBackDrop
          active={
            !apartmentsCfg.isLoaded
          }

          loader

          background="white"
        >
          {
            apartmentsCfg.isError
              ? (
                <ErrorResult
                  compact={true}
                />
              )
              : (
                <>
                  <div
                    style={{
                      display:
                        'flex',

                      justifyContent:
                        'flex-end',

                      marginBottom:
                        '16px'
                    }}
                  >
                    <Button
                      type="primary"

                      icon={
                        <PlusOutlined />
                      }

                      onClick={
                        handlerOpenAddApartment
                      }
                    >
                      Afegir habitatge
                    </Button>
                  </div>


                  {
                    apartmentsCfg.isLoaded &&
                      _.isEmpty(
                        apartmentsCfg.assigned
                      )
                      ? (
                        <EmptyResult
                          compact={true}
                        />
                      )
                      : (
                        <Table
                          rowKey="apartment_id"

                          columns={
                            apartmentColumns
                          }

                          dataSource={
                            apartmentsCfg.assigned
                          }

                          pagination={
                            false
                          }

                          size="middle"

                          scroll={{
                            x: true
                          }}
                        />
                      )
                  }
                </>
              )
          }
        </LoaderBackDrop>
      </Modal>


      {/*
        * ADD / EDIT APARTMENT RELATION
        */}
      <Modal
        open={
          apartmentModalCfg.open
        }

        title={
          apartmentModalCfg.mode === 'edit'
            ? 'Editar habitatge'
            : 'Afegir habitatge'
        }

        onCancel={
          handlerCloseApartmentModal
        }

        footer={
          null
        }

        destroyOnClose
      >
        <Form
          form={
            apartmentForm
          }

          layout="vertical"

          name="promotion_residential_user_apartment_form"

          onFinish={
            handlerApartmentFinish
          }

          initialValues={{
            user_is_apartment_tenant:
              true,

            user_is_apartment_owner:
              false
          }}
        >
          <Row
            gutter={
              16
            }
          >
            <Col
              span={
                24
              }
            >
              <Form.Item
                label="Habitatge"

                name="apartment_id"

                rules={[
                  {
                    required:
                      true,

                    message:
                      'Selecciona un habitatge'
                  }
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="label"
                  placeholder="Selecciona un habitatge"
                  style={{ width: '100%' }}
                  options={apartmentOptions}
                  value={_.get(apartmentModalCfg, 'selected.apartment_id', null)}
                  onChange={(value, option) => {
                    setApartmentModalCfg({
                      ...apartmentModalCfg,
                      selected: {
                        ...apartmentModalCfg.selected,
                        apartment_id: value,
                        apartment_label: _.get(option, 'label', '')
                      }
                    })
                  }}
                />
              </Form.Item>
            </Col>
          </Row>


          <Row
            gutter={
              16
            }
          >
            <Col
              span={
                12
              }
            >
              <Form.Item
                label="Llogater"

                name="user_is_apartment_tenant"

                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>


            <Col
              span={
                12
              }
            >
              <Form.Item
                label="Propietari"

                name="user_is_apartment_owner"

                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>


          <Row
            justify="end"
          >
            <Col>
              <Space>
                <Button
                  onClick={
                    handlerCloseApartmentModal
                  }

                  disabled={
                    apartmentModalCfg.isSubmitting
                  }
                >
                  Cancel·lar
                </Button>


                <Button
                  type="primary"

                  htmlType="submit"

                  loading={
                    apartmentModalCfg.isSubmitting
                  }
                >
                  {
                    apartmentModalCfg.mode === 'edit'
                      ? 'Actualitzar'
                      : 'Afegir'
                  }
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}